// extracted by mini-css-extract-plugin
export default {"content":"Location_content__scQqS","map":"Location_map__Re8HM","img":"Location_img__pk58q","list":"Location_list__5kkBE","textBlock":"Location_textBlock__VeHjT"};